import { Pagination } from 'store/interfaces';

export default function canLoadMore({ limit, total, page }: Pagination) {
  return total > limit * page;
}
